<script setup>
import { onMounted } from 'vue'
import AgentLayout from './layouts/AgentLayout.vue'
import AttachmentsAnalytics from '../components/AttachmentsAnalytics.vue'

onMounted(() => {
    // Any specific logic for View mount
})
</script>

<template>
  <AgentLayout>
    <AttachmentsAnalytics />
  </AgentLayout>
</template>
